import React from "react";
import {Trans, useTranslation} from "react-i18next";
import {Tab, Tabs} from "react-bootstrap";

export default function Terms(props) {
    const {t} = useTranslation();

    let mainClass = props.mainClass;
    if (mainClass == null) {
        mainClass = "main-content";
    }

    return (
        <div className={mainClass}>
            <Tabs defaultActiveKey="termsAndCond" id="docs-tabs" transition={false}>
                <Tab eventKey="termsAndCond" title={t('termsAndCond')}>
                    <span className={'client-title'}>
                        {t('termsAndCond')}
                    </span>
                    <div style={{paddingTop: '20px'}}>
                        <Trans i18nKey="termsContent" components={{p: <p/>, header: <p className="terms-and-cond"/>}}/>
                    </div>
                </Tab>
                <Tab eventKey="termsOfUse" title={t('termsOfUse')}>
                    <span className={'client-title'}>
                        {t('termsOfUseFull')}
                    </span>
                    <div style={{paddingTop: '20px'}}>
                        <Trans i18nKey="termsOfUseContent" components={{p: <p/>, header: <p className="terms-and-cond"/>}}/>
                    </div>
                </Tab>
            </Tabs>
        </div>
    );
}
